import { render } from "./Acomodacoes.vue?vue&type=template&id=d07d627c&scoped=true"
import script from "./Acomodacoes.vue?vue&type=script&lang=js"
export * from "./Acomodacoes.vue?vue&type=script&lang=js"

import "./Acomodacoes.vue?vue&type=style&index=0&id=d07d627c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07d627c"]])

export default __exports__